import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { useCountryContext } from '../../../context';
import { UniversalHeader } from '..';
import { useLocalUser } from '../../../hooks/use-local-user';
import { jsx as _jsx } from "react/jsx-runtime";
function selectLogo(variant) {
  switch (variant) {
    case 'national':
    case 'centre':
    case 'gift-cards':
    case 'account':
      return 'westfield-red';
    case 'direct':
      // for RCO we want to use the new Westfield logo instead of the new Westfiled Online logo in the header
      return 'westfield-red';
    case 'westfield-plus':
      return 'westfield-plus';
    default:
      return undefined;
  }
}
function getLogoUrl(centre, variant) {
  if (centre) {
    return "/".concat(centre.slug);
  } else if (variant === 'gift-cards') {
    return '/gift-cards';
  } else {
    return '/';
  }
}
export function useUniversalHeader(options) {
  const country = useCountryContext();
  const user = useLocalUser();
  const [navPath, setNavPath] = React.useState();
  return React.useMemo(() => {
    if (!(options !== null && options !== void 0 && options.data)) {
      return [() => null, setNavPath];
    }
    const {
      hasBottomMargin,
      logoText,
      hideMegaMenu
    } = options;
    const variant = options.variant;
    const data = options.data;
    const {
      centres,
      giftCards,
      navigationMenu
    } = data;
    const centre = 'centre' in data ? data.centre : undefined;
    return [() => /*#__PURE__*/_jsx(UniversalHeader, {
      firstName: user === null || user === void 0 ? void 0 : user.firstName,
      isLoggedIn: (user === null || user === void 0 ? void 0 : user.isLoggedIn) || false,
      navPath: navPath,
      logo: selectLogo(variant),
      hasBottomMargin: hasBottomMargin,
      logoText: logoText,
      country: country,
      hideMegaMenu: hideMegaMenu,
      hamburgerMenuProps: _objectSpread(_objectSpread({
        country,
        giftCards,
        menuId: 'national',
        onClose: () => setNavPath(undefined)
      }, navigationMenu ? {
        shop: {
          navigationMenu
        }
      } : {}), {}, {
        centre
      }),
      logoUrl: getLogoUrl(centre, variant),
      headerTabsProps: {
        variant,
        centres,
        centre,
        primaryLinks: data.primaryLinks,
        tertiaryLinks: data.tertiaryLinks,
        openHamburgerMenuAtPath: () => undefined
      },
      "data-id": "use-universal-header_index_useUniversalHeader_UniversalHeader"
    }), setNavPath];
  }, [options, user === null || user === void 0 ? void 0 : user.firstName, user === null || user === void 0 ? void 0 : user.isLoggedIn, navPath, country]);
}